import React from "react"
import "./page-divider.scss"

const PageDivider = () => <div className="page-divider" />

export default PageDivider
